module.exports = __webpack_public_path__ + "5cfafb04562382d97d17c573b5ee8aca.pdf";